import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-182b89b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pic" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "txt" }
const _hoisted_4 = { class: "title nowrap" }
const _hoisted_5 = { class: "price" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-fl-renminbi" }, null, -1))
const _hoisted_7 = { class: "views" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "goods-item",
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goto && _ctx.goto(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "pic-img",
        src: _ctx.changeUrl(_ctx.goods.photo)
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.goods.names), 1),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createTextVNode(_toDisplayString(_ctx.showPrice(_ctx.goods.price, 1)), 1)
      ]),
      _createElementVNode("div", {
        class: "price",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.goods.click) + "次浏览", 1),
        _createElementVNode("i", {
          class: "icon iconfont icon-gouwuche",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addCart && _ctx.addCart(...args)))
        })
      ])
    ])
  ]))
}